import { StateCreator } from 'zustand';

export const initialSidePanelSliceState: boolean = false;

export interface SidePanelSlice {
    isSidePanelOpen: boolean;
    toggleSidePanel: () => void;
}

export const createSidePanelSlice: StateCreator<SidePanelSlice, [], [], SidePanelSlice> = (set) => ({
    isSidePanelOpen: initialSidePanelSliceState,
    toggleSidePanel: () => set((state) => ({ isSidePanelOpen: !state.isSidePanelOpen }))
});
